/* @flow */

// $FlowFixMe
module.exports = require('./dist/paypal-sdk-constants'); // eslint-disable-line import/no-commonjs
